import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { SCHEDULE_TABS } from '../../types'

function AgendaSwitch (props) {
    const handleTabChange = (_, newValue) => {
      if (newValue !== null) {
        props.setTab(newValue);
      }
    };

    return (
    <ToggleButtonGroup
      color="primary"
      value={props.tab}
      exclusive
      onChange={handleTabChange}
      aria-label="Platform"
      sx={{
        backgroundColor: '#f4f5f7',
      }}
    >
      <ToggleButton
        value={SCHEDULE_TABS.MINHA_AGENDA}
        sx={{
          height: '30px',
          backgroundColor: props.tab === SCHEDULE_TABS.MINHA_AGENDA ? 'white' : '#dfe0e2',
          color: props.tab === SCHEDULE_TABS.MINHA_AGENDA ? 'black' : 'white',
          textTransform: 'none',
          margin: '0 !important',
          border: '2px solid #dfe0e2 !important',
          borderRadius: 'inherit !important',
          '&.Mui-selected': {
            backgroundColor: 'white',
            color: 'black',
          },
          '&:not(.Mui-selected)': {
            border: "none !important",
            backgroundColor: 'transparent',
            color: '#606162',
          },
        }}
      >
        Minha agenda
      </ToggleButton>
      <ToggleButton
        value={SCHEDULE_TABS.GERAL}
        sx={{
          height: '30px',
          backgroundColor: props.tab === SCHEDULE_TABS.GERAL ? 'white' : '#dfe0e2',
          color: props.tab === SCHEDULE_TABS.GERAL ? 'black' : 'white',
          textTransform: 'none',
          margin: '0 !important',
          border: '2px solid #dfe0e2 !important',
          borderRadius: 'inherit !important',
          '&.Mui-selected': {
            backgroundColor: 'white',
            color: 'black',
          },
          '&:not(.Mui-selected)': {
            border: 'none !important',
            backgroundColor: 'transparent',
            color: '#606162',
          },
        }}
      >
        Geral
      </ToggleButton>
      <ToggleButton
        value={SCHEDULE_TABS.E_AGENDA}
        sx={{
          height: '30px',
          backgroundColor: props.tab === SCHEDULE_TABS.E_AGENDA ? 'white' : '#dfe0e2',
          color: props.tab === SCHEDULE_TABS.E_AGENDA ? 'black' : 'white',
          textTransform: 'none',
          margin: '0 !important',
          border: '2px solid #dfe0e2 !important',
          borderRadius: 'inherit !important',
          '&.Mui-selected': {
            backgroundColor: 'white',
            color: 'black',
          },
          '&:not(.Mui-selected)': {
            border: "none !important",
            backgroundColor: 'transparent',
            color: '#606162',
          },
        }}
      >
        E-agendas
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default AgendaSwitch
